import React from 'react'

export interface SceneContextTypes {
  hitBoxGroupName: string
  hitboxVisible: boolean
  disablePuck: boolean
}

const initContextValue: SceneContextTypes = {
  hitBoxGroupName: '',
  hitboxVisible: false,
  disablePuck: false,
}

const SceneContext = React.createContext(initContextValue)

export default SceneContext
